import * as React from 'react';

import dragIcon from './icons/drag.svg';

export const DragIcon: React.FunctionComponent<{ className?: string }> = ({ className }) => (
  <img className={className} src={dragIcon} draggable="false" />
);
